import {DELETE_ALL_USER as SOCKET_DELETE_ALL_USER} from '../../events/DashboardToServer'
import {PLAYER_ADDED, PLAYER_REMOVED, ALL_USER_DELETED} from '../../events/ServerToClient'
import { USER_DELETED } from '../user/actions';

export const USER_LOGGED_IN = 'USER_LOGGED_IN'
export const USER_LOGGED_OUT = 'USER_LOGGED_OUT'
export const DELETE_ALL_USER = 'DELETE_ALL_USER'
export const ADD_IMPROVISER = 'ADD_IMPROVISER'
export const IMPROVISER_ADDED = 'IMPROVISER_ADDED'
export const REMOVE_IMPROVISER = 'REMOVE_IMPROVISER'
export const IMPROVISER_REMOVED = 'IMPROVISER_REMOVED'

export const users = (state = {}, action) => {
    switch (action.type) {
    
        case USER_DELETED:
            var e = {
                ...state
            }
            if (e[action.user_id])
                delete e[action.user_id]
            return e;

        case IMPROVISER_ADDED: 
            var e = {
                ...state
            }
            if (e.improvisersIds == undefined || e.improvisersIds == null) e.improvisersIds = [];
            e.improvisersIds.push({user_name:action.user_name, user_id:action.user_id});
            return e;

        case IMPROVISER_REMOVED: 
            var e = {
                ...state
            }
            //cancellare un elemento da un array TODO
            let newarray = [];
            for (var i = 0; i < e.improvisersIds.length; i++){
                if (e.improvisersIds[i].user_id != action.user_id) newarray.push({user_name:e.improvisersIds[i].user_name, user_id:e.improvisersIds[i].user_id})
            }
            e.improvisersIds = newarray
            return e;
        
        
        case USER_LOGGED_IN:
            var e = {
                ...state
            };
            if (!(e[action.user.id])){
                // Se entro qui detto vuol dire che l'utente si è registrato
            // dopo il log del conduttore 
                e[action.user.id] ={
                    ...action.user,
                }
            }
            e[action.user.id] = {
                ...e[action.user.id], 
                is_connected : !action.user.error?1:0,
            }
            return e;

        case USER_LOGGED_OUT:
            var e = {
                ...state
            };
            e[action.user.id] = {
                ...e[action.user.id], 
                is_connected : 0
            }
            return e;

        case PLAYER_ADDED:
            var e = {
                ...state
            };
            e[action.user_id] = {
                ...e[action.user_id], 
                is_playing : 1
            }
            return e;

        case PLAYER_REMOVED:
            var e = {
                ...state
            };
            e[action.user_id] = {
                ...e[action.user_id], 
                is_playing : 0
            }
            return e;
                
        default:
            return state
    }
}



export const playerAdded = (user_id) => {
    return { type: PLAYER_ADDED , user_id}
}

export const playerRemoved = (user_id) => {
    return { type: PLAYER_REMOVED, user_id}
}

export const userLoggedIn = (user) => {
    return {type: USER_LOGGED_IN, user}
}

export const userLoggedOut = (user) => {
    return {type: USER_LOGGED_OUT, user}
}

export const allUserDeleted = () => {
    return {type:ALL_USER_DELETED}
}

export const deleteAllUsers =(socket) => {
    socket.emit(SOCKET_DELETE_ALL_USER);
    return {type: DELETE_ALL_USER}
}

export const improviserAdded = ({user_name, user_id}) => {
    return {type:IMPROVISER_ADDED, user_name:user_name, user_id:user_id}
}


export const improviserRemoved = ({user_id}) => {
    return {type:IMPROVISER_REMOVED, user_id:user_id}
}



// WEBPACK FOOTER //
// ./src/reducers/users/index.js